export { BonnetModule, BonnetModule as Module } from './modules/BonnetModule.js';
